export const defaultColors = {
  backgroundColor: '#ffffff',
  borderLeftColor: '#E5E6E8',
};

export const automaticEventColorCycle = [defaultColors] as const;

export const outlookPresetColors: Record<string, string> = {
  preset0: '#eeacb2',
  preset1: '#e5bba4',
  preset3: '#f9e2ae',
  preset4: '#a7e3a5',
  preset7: '#b0eafb',
  preset8: '#d2ccf8',
};
